import { cva } from "@-/com.npmjs.cva";
import { cn } from "@-/com.npmjs.cn";
import { Platform } from "@-/com.npmjs.react-native";

export const badgeVariants = cva({
  base: cn(
    "group shrink-0 flex-row items-center justify-center gap-1 overflow-hidden rounded-full border border-border px-2 py-0.5",
    Platform.select({
      web: "focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive w-fit whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] [&>svg]:pointer-events-none [&>svg]:size-3",
    }),
  ),
  defaultVariants: {
    variant: "default",
  },
  variants: {
    variant: {
      default: cn(
        "border-transparent bg-primary",
        Platform.select({ web: "[a&]:hover:bg-primary/90" }),
      ),
      destructive: cn(
        "border-transparent bg-destructive",
        Platform.select({ web: "[a&]:hover:bg-destructive/90" }),
      ),
      outline: Platform.select({ web: "[a&]:hover:bg-accent [a&]:hover:text-accent-foreground" }),
      secondary: cn(
        "border-transparent bg-secondary",
        Platform.select({ web: "[a&]:hover:bg-secondary/90" }),
      ),
    },
  },
});

export const badgeTextVariants = cva({
  base: "text-xs font-medium",
  defaultVariants: {
    variant: "default",
  },
  variants: {
    variant: {
      default: "text-primary-foreground",
      destructive: "text-white",
      outline: "text-foreground",
      secondary: "text-secondary-foreground",
    },
  },
});
